import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaYoutube } from 'react-icons/fa';
import { IconContext } from 'react-icons';

const Login: React.FC = () => {
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  
  const { login, loading, error } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    await login(email, password);
    navigate('/admin/dashboard');
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-900">
      <div className="w-full max-w-md p-8 bg-gray-800 rounded-lg shadow-xl border border-gray-700">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-serif mb-2 text-white">𝓨𝓸𝓱𝓪𝓷𝓥𝓲𝓼𝓲𝓸𝓷</h1>
          <p className="text-gray-400">Interface d'administration</p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-center mb-6 text-white">Connexion</h2>
          {error && (
            <div className="mb-4 p-3 bg-red-900/30 text-red-200 rounded-md border border-red-800">
              {error}
            </div>
          )}
          <form onSubmit={handleLogin}>
            <div className="mb-4">
              <label htmlFor="email" className="block text-gray-300 mb-2">
                Email
              </label>
              <input
                type="email"
                id="email"
                className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400 text-white"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="mb-6">
              <label htmlFor="password" className="block text-gray-300 mb-2">
                Mot de passe
              </label>
              <input
                type="password"
                id="password"
                className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400 text-white"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button
              type="submit"
              className="w-full py-3 px-4 bg-gray-700 text-white rounded-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
              disabled={loading}
            >
              {loading ? 'Connexion en cours...' : 'Se connecter'}
            </button>
          </form>
        </div>
        
        {/* Réseaux sociaux */}
        <div className="mt-8 pt-6 border-t border-gray-700">
          <div className="flex justify-center space-x-6">
            {[
              {
                href: 'https://www.facebook.com/profile.php?id=100010381140256&locale=fr_CA',
                icon: FaFacebookF,
                label: 'Facebook',
              },
              {
                href: 'https://www.instagram.com/yohan.p0v/',
                icon: FaInstagram,
                label: 'Instagram',
              },
              {
                href: 'https://www.youtube.com/@yohan.p0v',
                icon: FaYoutube,
                label: 'YouTube',
              },
            ].map((social) => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
                aria-label={social.label}
              >
                <IconContext.Provider value={{ size: '1.5em' }}>
                  <social.icon />
                </IconContext.Provider>
              </a>
            ))}
          </div>
          <p className="mt-4 text-center text-sm text-gray-500">
            {new Date().getFullYear()} YohanVision INC. Tous droits réservés.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
